import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function MinusIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 32 32">
      <path
        d="M9.333 17.333a1.3 1.3 0 0 1-.95-.383A1.3 1.3 0 0 1 8 16q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383h13.334q.566 0 .95.383.383.383.383.95 0 .566-.383.95a1.3 1.3 0 0 1-.95.383z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
